import { addAuthorizationToHeader } from "./authorize";
import { BASE_PATH } from "./base";
export const TRANSLATE_PATH = BASE_PATH + "/translate";
export const translate = async (text) => {
    const headers = new Headers();
    addAuthorizationToHeader(headers);
    headers.set("Content-Type", "application/json");
    return fetch(TRANSLATE_PATH, {
        method: "POST",
        headers,
        body: JSON.stringify({ text }),
    }).then((response) => {
        if (response.ok) {
            return response.json();
        }
        else {
            throw new Error(response.statusText);
        }
    }).then((data) => data.result);
};
